import React from "react";

const greetings = [
    ["Thank you", "Gracias", "Merci", "Danke", "Grazie"],
    ["Obrigado", "Děkuji", "Tack", "Mulțumesc"],
    ["谢谢", "ありがとう", "감사합니다", "Спасибо", "Terima kasih"],
    ["شكرا", "תודה", "ขอบคุณ", "Chokran"],
];

export default function ThankYouAnimation() {
    const renderRow = (words, rowIndex) => (
        <div className="customerThankYouRow" key={words[0]}>
            {words.map((word, index) => (
                <span key={word} style={{ animationDelay: `${0.25 + rowIndex * 0.18 + index * 0.1}s` }}>
                    {word}
                </span>
            ))}
        </div>
    );

    return (
        <div className="customerThankYou">
            {greetings.slice(0, 2).map(renderRow)}
            <div className="customerThankYouTitle" lang="hu">Köszönjük!</div>
            {greetings.slice(2).map((words, index) => renderRow(words, index + 2))}
        </div>
    );
}
